import React, { useEffect, useState, useRef } from "react";
import swal from "sweetalert";
import {
  Col,
  Card,
  Table,
  Modal,
  Alert,
  Spinner,
  Dropdown,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { Multiselect } from "multiselect-react-dropdown";
import Switch from "react-switch";
function GroceryBanners() {
  var history = useHistory();
  const data = document.querySelectorAll("#job_data tbody tr");
  const sort = 5;
  const activePag = useRef(0);
  const [imageKey, setImageKey] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [selectedSubShop, setSelectedSubShop] = useState("");
  const [allCategory, setAllCategory] = useState([]);
  const [subShop, setSubShop] = useState([]);
  const [allSubCategory, setAllSubCategory] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [imageData, setImageData] = useState(null);
  const [image, setImage] = useState(null);
  const [categoryName, setCategoryName] = useState("");
  const handleClose = () => setShow(false);
  const [show, setShow] = useState(false);
  const [categoryStatus, setCategoryStatus] = useState(false);
  const [subShopStatus, setSubShopStatus] = useState(false);
  const [itemsStatus, setItemsStatus] = useState(false);
  const [catId, setCatId] = useState("");
  const [spinner, setSpinner] = useState(true);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [show1, setShow1] = useState(false);
  const [itemIds, setItemIds] = useState([]);
  const [itemDetails, setItemDetails] = useState([]);
  const [selectedItemsIds, setSelectedItemsIds] = useState([]);
  function getData() {
    axios
      .get(`${Baseurl.baseurl6}/go-grocery/banner/get-all-grocery-banner`)
      .then((res) => {
        console.log("categoiryeueye", res.data.details);
        setSpinner(false);
        if (res.data.status) {
          setAllSubCategory(res.data.details);
          setSearchData(res.data.details);
        }
      });
  }
  function getCategory() {
    axios
      .get(`${Baseurl.baseurl6}/go-grocery/sub-shop/get-all-sub-shop`)
      .then((res) => {
        setSubShop(res.data.details);
      });
    axios
      .get(`${Baseurl.baseurl6}/go-grocery/item/get-all-item-details`)
      .then((res) => {
        setItemDetails(res.data.details);
      });
    axios
      .get(`${Baseurl.baseurl6}/go-grocery/category/get-all-grocery-category`)
      .then((res) => {
        if (res.data.status) {
         
          setAllCategory(res.data.details);
        } else {
          swal(
            "Oops",
            "please create the category to add subcategory",
            "error",
            {
              button: "Done",
              timer: 2000,
            }
          );
        }
      });
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };

  useEffect(() => {
    getData();
  }, []);

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  function searchRider(value) {
    let filteredData = [];
    searchData.map((val) => {
      if (
        val.Name.toLowerCase().includes(value) ||
        val.CategoryId.Name.toLowerCase().includes(value)
      ) {
        filteredData.push(val);
      }
    });
    setAllSubCategory(filteredData);
  }
  const onChangePicture = (e) => {
    if (e.target.files[0].size / 1048576 < 3) {
      setImage(e.target.files[0]);
      if (e.target.files[0]) {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          setImageData(reader.result);
        });
        reader.readAsDataURL(e.target.files[0]);
      }
    } else {
      swal("Oops", "image size should be less than 3MB", "error", {
        button: "Done",
        timer: 2000,
      });
      setImageData(null);
    }
  };
  function addBanner() {
    const data = new FormData();
    data.append("image", image);
    data.append("name", categoryName);
    if (subShopStatus) {
      data.append("subShopId", selectedSubShop);
    }
    if (categoryStatus) {
      data.append("categoryId", selectedId);
    }

    data.append("subCategoryId", []);
    if (itemIds.length !== 0) {
      itemIds.map((val) => {
        data.append("itemId", val);
      });
    }
    data.append("category", categoryStatus);
    data.append("subShop", subShopStatus);
    data.append("item", itemsStatus);
    var config = {
      method: "post",
      url: `${Baseurl.baseurl6}/go-grocery/banner/create-grocery-banner`,
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.status) {
          getData();
          setImage(null);
          setImageData(null);

          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {});

    handleClose();
  }
  function updateBanner() {
    let catFields;
    if (categoryStatus) {
      catFields = {
        name: categoryName,
        categoryId: selectedId,
      };
    }
    if (subShopStatus) {
      catFields = {
        name: categoryName,
        subShopId: selectedSubShop,
      };
    }
    if (itemsStatus) {
      catFields = {
        name: categoryName,
        itemId: itemIds,
      };
    }

    axios
      .put(
        `${Baseurl.baseurl6}/go-grocery/banner/update-grocery-banner-details/${catId}`,
        catFields
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    handleClose();
  }
  function updateBannerImage() {
    const data = new FormData();
    data.append("image", image);
    var config = {
      method: "put",
      url: `${Baseurl.baseurl6}/go-grocery/banner/update-grocery-banner-image/${catId}`,
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.status) {
          getData();
          setImage(null);
          setImageData(null);
          swal("updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });

    handleClose();
  }
  function deleteBanner() {
    axios
      .delete(
        `${Baseurl.baseurl6}/go-grocery/banner/delete-grocery-banner-details/${catId}`
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    setShow1(false);
  }

  function updateFunction(val) {
    getCategory();
    setCatId(val._id);
    setUpdateStatus(true);
    setSubShopStatus(val.SubShop);
    setCategoryStatus(val.Category);
    setItemsStatus(val.Item);
    setCategoryName(val.Name);
    if (val.SubShop) {
      setSelectedSubShop(val.SubShopId._id);
    }
    if (val.Category) {
      setSelectedId(val.CategoryId._id);
    }

    if (val.Item) {
      setSelectedItemsIds(val.ItemId);
    }
    setImageData(val.Image);
    setImageKey(val.ImageKey);
    setShow(true);
  }
  const selection1 = (selectedValues) => {
    console.log("selected", selectedValues);
    let name = [];
    selectedValues.map((val) => {
      name.push(val._id);
    });
    setItemIds(name);
  };
  return (
    <Col lg={12}>
      <Modal
        show={show1}
        onHide={() => {
          setShow1(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Banner</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <h4>Are You Sure You Want to Delete This Banner ?</h4>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => {
              deleteBanner();
            }}
            className="btn btn-primary"
          >
            Delete
          </button>
        </Modal.Footer>
      </Modal>
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> Add Banner</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="row">
              <div className="col-sm-2">
                <label>Category</label>
              </div>
              <div className="col-sm-2">
                <Switch
                  onChange={() => {
                    setCategoryStatus(!categoryStatus);
                    setSubShopStatus(false);
                    setItemsStatus(false);
                  }}
                  checked={categoryStatus}
                />
              </div>
              <div className="col-sm-2">
                <label>SubShop</label>
              </div>
              <div className="col-sm-2">
                <Switch
                  onChange={() => {
                    setSubShopStatus(!subShopStatus);
                    setCategoryStatus(false);
                    setItemsStatus(false);
                  }}
                  checked={subShopStatus}
                />
              </div>
              <div className="col-sm-2">
                <label>Items</label>
              </div>
              <div className="col-sm-2">
                <Switch
                  onChange={() => {
                    setItemsStatus(!itemsStatus);
                    setSubShopStatus(false);
                    setCategoryStatus(false);
                  }}
                  checked={itemsStatus}
                />
              </div>
            </div>
            <div className="row mt-5">
              {categoryStatus && (
                <>
                  <div className="col-sm-2 mt-2">
                    <label>
                      Category<span className="text-danger">*</span>
                    </label>
                  </div>
                  <div className="col-sm-4">
                    <select
                      required
                      value={selectedId}
                      className="form-control"
                      id="val-skill"
                      name="val-skill"
                      onChange={(event) => {
                        setSelectedId(event.target.value);
                      }}
                    >
                      <option selected="true" disabled="disabled"></option>
                      {allCategory &&
                        allCategory.map((val) => (
                          <option value={val._id}>{val.Name}</option>
                        ))}
                    </select>
                  </div>
                </>
              )}
              {subShopStatus && (
                <>
                  <div className="col-sm-2 mt-2">
                    <label>
                      Sub Shop<span className="text-danger">*</span>
                    </label>
                  </div>
                  <div className="col-sm-4">
                    <select
                      required
                      value={selectedSubShop}
                      className="form-control"
                      id="val-skill"
                      name="val-skill"
                      onChange={(event) => {
                        setSelectedSubShop(event.target.value);
                      }}
                    >
                      <option selected="true" disabled="disabled"></option>
                      {subShop &&
                        subShop.map((val) => (
                          <option value={val._id}>{val.Name}</option>
                        ))}
                    </select>
                  </div>
                </>
              )}
              {itemsStatus && (
                <>
                  <div className="col-sm-2 mt-2">
                    <label htmlFor="val-range">
                      Items
                      <span className="text-danger">*</span>
                    </label>
                  </div>
                  <div className="col-sm-4">
                    <Multiselect
                      options={itemDetails}
                      displayValue="Name"
                      onSelect={selection1}
                      selectedValues={selectedItemsIds}
                    />
                  </div>
                </>
              )}

              <div className="col-sm-2 mt-2">
                <label>
                  Name <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-4">
                <input
                  value={categoryName}
                  type="text"
                  className="form-control"
                  placeholder="enter Name"
                  onChange={(e) => setCategoryName(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-sm-2 mt-2">
                <label htmlFor="val-range">
                  Image
                  <span className="text-danger">*</span>
                </label>
              </div>
              <div classname="col-sm-4">
                <div className="register_profile_image mt-2">
                  <input
                    id="profilePic"
                    type="file"
                    onChange={(e) => {
                      onChangePicture(e);
                    }}
                  />
                </div>
                {imageData && (
                  <div
                    style={{
                      marginTop: "5px",
                      width: 180,
                      height: 100,
                      aspectRatio: 1 * 1.4,
                    }}
                    className="previewProfilePic"
                  >
                    <img
                      alt=""
                      className="playerProfilePic_home_tile"
                      style={{
                        resizeMode: "cover",
                        width: "100%",
                        height: "100%",
                      }}
                      src={imageData}
                    />
                  </div>
                )}
                {updateStatus && (
                  <div className="col-sm-2 ">
                    <button
                      onClick={() => {
                        updateBannerImage();
                      }}
                      className="btn btn-primary mt-3"
                    >
                      Change
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {updateStatus ? (
            <button
              className="btn btn-primary"
              onClick={() => {
                updateBanner();
              }}
            >
              Update
            </button>
          ) : (
            <button
              className="btn btn-primary"
              onClick={() => {
                addBanner();
              }}
            >
              Submit
            </button>
          )}
        </Modal.Footer>
      </Modal>

      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Header>
          <div>
            <input
              type="text"
              className="form-control"
              placeholder="Search here..."
              onChange={(e) => {
                searchRider(e.target.value);
              }}
            />
          </div>
          <button
            onClick={() => {
              getCategory();
              setSelectedId("");
              setSelectedSubShop("");
              setItemIds([]);
              setShow(true);
              setUpdateStatus(false);
              setCategoryName("");
            }}
            className="btn btn-primary"
          >
            Add Banner
          </button>
        </Card.Header>
        <Card.Body>
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table className="text-white" responsive>
                <thead>
                  <tr>
                    <th>
                      <strong>SL NO.</strong>
                    </th>

                    <th>
                      <strong>Image</strong>
                    </th>

                    <th>
                      <strong> Name</strong>
                    </th>

                    <th>
                      <strong>Actions</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {allSubCategory &&
                    allSubCategory.map((val, key) => (
                      <tr key={val._id}>
                        <td>{key + 1}</td>
                        <td>
                          <img
                            src={val.Image}
                            height={40}
                            width={40}
                            alt="profile"
                          />
                        </td>
                        <td>{val.Name}</td>

                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="warning"
                              className="light sharp i-false"
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                  updateFunction(val);
                                }}
                              >
                                Update
                              </Dropdown.Item>

                              <Dropdown.Item
                                onClick={() => {
                                  setCatId(val._id);
                                  setShow1(true);
                                }}
                              >
                                Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}

            {!allSubCategory && (
              <Alert
                variant="success"
                className="alert-dismissible fade show text-center"
              >
                Zero allCategory
              </Alert>
            )}
            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {data.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : data.length}{" "}
                of {data.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default GroceryBanners;
